import React, { FC } from "react";
import { colors } from "~/utils/colors";
import { breakPoints } from "~/utils/variables";
import { IoMdArrowForward } from "@react-icons/all-files/io/IoMdArrowForward";

type InPageLinksType = {};

export const LpRpo01PageInPageLinks: FC<InPageLinksType> = () => {
  return (
    <>
      <div className="container">
        <a href="#whyChooseUs" className="link">
          <span className="linkText">選ばれる理由</span>
          <IoMdArrowForward style={{ fontSize: 14 }} />
        </a>
        <a href="#cases" className="link">
          <span className="linkText">Refcomeの実績・導入事例</span>
          <IoMdArrowForward style={{ fontSize: 14 }} />
        </a>
        <a href="#price" className="link">
          <span className="linkText">ご利用料金</span>
          <IoMdArrowForward style={{ fontSize: 14 }} />
        </a>
        <a href="#questions" className="link">
          <span className="linkText">よくある質問</span>
          <IoMdArrowForward style={{ fontSize: 14 }} />
        </a>
      </div>

      <style jsx>{`
        .container {
          display: flex;
          justify-content: center;
          height: 60px;
          padding: 8px 20px;
          background: ${colors.brandGradient};
        }
        .link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 250px;
          border-right: 1px solid ${colors.white};
          color: ${colors.white};
          gap: 5px;
        }
        .linkText {
          color: ${colors.white};
          font-size: 14px;
          font-weight: 500;
        }
        @media (${breakPoints.sp}) {
          .container {
            height: auto;
            padding: 4px 0;
            flex-wrap: wrap;
          }
          .link {
            width: 50%;
            border-right: 0;
            padding: 4px 0;
          }
          .link:first-child {
            border-bottom: solid 0.5px ${colors.white};
            border-right: solid 0.5px ${colors.white};
          }
          .link:nth-child(2) {
            border-bottom: solid 0.5px ${colors.white};
          }
          .link:nth-child(3) {
            border-right: solid 0.5px ${colors.white};
          }
          .linkText {
            font-size: 12px;
          }
        }
      `}</style>
    </>
  );
};
